import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { ScreensStateService } from '../../core/services/screen-state/screens-state.service';
import { PlaylistStateService } from '../../core/services/screen-state/playlists-state.service';
import { UIService } from '../../core/services/utils/ui.service';
import { TagViewModel } from './../../core/models/view-models/tag-models/tag-view.model';
import { LibraryEditItemTypeEnum } from './../../core/enums/library-edit-item-type.enum';
import { PlaylistDTO } from './../../core/models/view-models/playlist-models/playlist-dto.model';
import { DropItemViewModel } from '../../core/interfaces/drop-item-data.view-model';
import { TagsStateService } from '../../core/services/screen-state/tags-state.service';
import { LicenseService } from '../../core/services/http-services/license.service';
import { AppConstants } from '../../app.constants';

@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          height: '120px',
        })
      ),
      state(
        'closed',
        style({
          height: '0px',
        })
      ),
      state(
        'top',
        style({
          bottom: '120px',
        })
      ),
      state(
        'bottom',
        style({
          bottom: '0px',
        })
      ),
    ]),
  ],
})
export class DashboardComponent implements OnDestroy, OnInit {
  public isBottomPanelVisible: boolean;
  public libraryEditItemTypes = LibraryEditItemTypeEnum;
  public editItem: {
    item: PlaylistDTO | TagViewModel;
    type: LibraryEditItemTypeEnum;
  } = null;

  private subscriptions: Subscription[] = [];
  private isMonitorsSelectionAvailable: boolean = false;

  @HostListener('mousemove', ['$event'])
  onMousemove(mouseEvent: MouseEvent) {
    this.checkIfPossibleToSelectMonitors(mouseEvent);
  }

  @HostListener('window:keydown', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    this.checkIfPossibleToSelectMonitors(event);
    if ((event.ctrlKey || event.metaKey) && event.keyCode === AppConstants.A_LETTER_KEY_CODE && this.isMonitorsSelectionAvailable) {
      event.preventDefault();
      this.screensStateService.selectAll();
    }
  }

  constructor(
    public uiService: UIService,
    private readonly playlistStateService: PlaylistStateService,
    private readonly screensStateService: ScreensStateService,
    private readonly tagsStateService: TagsStateService,
    private readonly licenseService: LicenseService
  ) {
    this.subscriptions.push(
      this.uiService.itemlistDropSubject.subscribe((data: DropItemViewModel) => {
        this.screensStateService.selectScreen(data.Monitor, true);
        if (data.Itemlist.type === LibraryEditItemTypeEnum.EditTag) {
          this.tagsStateService.changeTag(data.Itemlist.data as TagViewModel);
          this.uiService.hideBottomPanel();
        } else if (data.Itemlist.type === LibraryEditItemTypeEnum.EditPlaylist) {
          this.playlistStateService.changePlaylist(data.Itemlist.data as PlaylistDTO);
          this.uiService.showBottomPanel();
        }
      })
    );

    this.subscriptions.push(
      this.uiService.libraryEditItem$.subscribe(
        (data) => (this.editItem = data)
      )
    );
  }

  ngOnInit(): void {
    if (this.licenseService.licenseStatusModel) {
      this.licenseService.checkIsToShowNotification(this.licenseService.licenseStatusModel);
    }

    this.subscriptions.push(
      this.uiService.bottomPanelVisibleSubject.subscribe((data) => {
        setTimeout(() => {
          this.isBottomPanelVisible = data;
        });
      })
    );
  }

  private checkIfPossibleToSelectMonitors(event: any): void {
    const isMouseOverMonitorSection: boolean = (event.target as HTMLElement).classList.contains(AppConstants.SELECTION_AREA_CLASS_NAME);
    const isMonitorSectionIsActive: boolean = document.activeElement.classList.contains(AppConstants.SELECTION_AREA_CLASS_NAME)
      || _.some(document.activeElement.classList, (className: string) => className.startsWith(AppConstants.MAT_CLASS_NAME_STARTS))
      || document.activeElement.tagName === AppConstants.BODY_TAG_NAME;

    this.isMonitorsSelectionAvailable = isMouseOverMonitorSection
      ? isMouseOverMonitorSection && isMonitorSectionIsActive
      : isMonitorSectionIsActive;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
